/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCoolingRegimeGenusDtoFromDiscriminatorValue, type CoolingRegimeGenusDto } from '../../../../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../../../../models/oDataErrors/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the coolingRegimeGenus property of the AapService.GenusDto entity.
 */
export interface WithCoolingRegimeGenusItemRequestBuilder extends BaseRequestBuilder<WithCoolingRegimeGenusItemRequestBuilder> {
    /**
     * Get coolingRegimeGenus from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CoolingRegimeGenusDto>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<WithCoolingRegimeGenusItemRequestBuilderGetQueryParameters> | undefined) : Promise<CoolingRegimeGenusDto | undefined>;
    /**
     * Get coolingRegimeGenus from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithCoolingRegimeGenusItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get coolingRegimeGenus from GenusOverview
 */
export interface WithCoolingRegimeGenusItemRequestBuilderGetQueryParameters {
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Select properties to be returned
     */
    select?: string[];
}
/**
 * Uri template for the request builder.
 */
export const WithCoolingRegimeGenusItemRequestBuilderUriTemplate = "{+baseurl}/GenusOverview/{genusId}/coolingRegimeGenus/{coolingRegimeGenusId}{?%24expand,%24select}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const WithCoolingRegimeGenusItemRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "expand": "%24expand",
    "select": "%24select",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCoolingRegimeGenusItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCoolingRegimeGenusItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCoolingRegimeGenusDtoFromDiscriminatorValue,
        queryParametersMapper: WithCoolingRegimeGenusItemRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
